import { connect } from 'react-redux';
import { AdminBenchmarks } from '../../components/pages/survey-admin/AdminBenchmarks';
import { IApplicationState } from '../../store';
import { ActionCreators as BenchmarksActionCreators } from '../../store/BenchmarksStore';
import { ActionCreators as NotificationActionCreators } from '../../store/NotificationStore';
import { SurveyBenchmarkActionCreators } from '../../store/SurveyBenchmarkActionCreators';

export const AdminBenchmarksPage: React.ComponentType<{ surveyId: number }> = connect(
	(state: IApplicationState) => ({ ...state.surveyAdmin, ...state.benchmarks }),
	{ ...SurveyBenchmarkActionCreators, ...BenchmarksActionCreators, ...NotificationActionCreators },
)(AdminBenchmarks);
